import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, Text } from '@olxbr/design-system'

const Container = styled(View)`
  border-radius: 24px;
  border: solid 0.5px ${props => props.borderColor};
  padding: 4px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

const Caption = styled(Text)`
  font-size: ${props => props.fontSize}px;
  text-align: center;
  color: ${props => props.fontColor};
  flex: 1;
  font-weight: ${props => props.fontWeight};
`

const LabelBox = ({ children, fontSize, fontColor, fontWeight, borderColor }) => (
  <Container borderColor={borderColor}>
    <Caption fontSize={fontSize} fontWeight={fontWeight} fontColor={fontColor}>
      {children}
    </Caption>
  </Container>
)

LabelBox.defaultProps = {
  fontSize: 14,
  fontWeight: 300,
  fontColor: '#4a4a4a',
  borderColor: '#d2d2d2',
}

LabelBox.propTypes = {
  fontSize: PropTypes.number,
  fontWeight: PropTypes.number,
  fontColor: PropTypes.string,
  borderColor: PropTypes.string,
}

export default LabelBox
